import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as modalActions from 'components/Modals/actions';

export default connect(null, dispatch =>
  bindActionCreators({ ...modalActions }, dispatch),
);
